import { render, staticRenderFns } from "./wishDate.vue?vue&type=template&id=42324062&scoped=true"
import script from "./wishDate.vue?vue&type=script&lang=ts"
export * from "./wishDate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42324062",
  null
  
)

export default component.exports